/**
 * Shared layout constants for CalendarView components
 * Single source of truth for consistent spacing
 */

export const RESERVED_BOTTOM_SPACE_PX = 42;
export const DATE_NUMBER_AREA_PX = 36;
export const DATE_NUMBER_AREA_COMPACT_PX = 32;
export const JOB_PILL_HEIGHT_PX = 28;
export const JOB_PILL_MARGIN_PX = 4;

// Backwards-compatible aliases
export const MONTHLY_DATE_NUMBER_AREA = DATE_NUMBER_AREA_PX;
export const MONTHLY_JOB_PILL_HEIGHT = JOB_PILL_HEIGHT_PX;
export const MONTHLY_JOB_PILL_MARGIN = JOB_PILL_MARGIN_PX;

// Programmatic navigation guard duration
export const PROGRAMMATIC_NAV_DURATION_MS = 1200;
